import KoobLayout from '../components/Koob/KoobLayout';
import KoobTitle from '../components/Koob/KoobTitle';
import KoobParagraph from '../components/Koob/KoobParagraph';

/** The 404 message, for pages already inside the layout. */
export function NotFoundContent() {
  return (
    <div className="flex flex-col items-center justify-center h-[85vh]">
      <KoobTitle size="text-5xl">404 - Not Found</KoobTitle>
      <KoobParagraph size="xl">
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        The page you're looking for doesn't exist.
      </KoobParagraph>
    </div>
  );
}

export default function NotFound() {
  return (
    <KoobLayout>
      <NotFoundContent />
    </KoobLayout>
  );
}
